<template>
  <div class="container">
    <h2 class="page-title">
      Outcomes with different 1L chemotherapy regimens<br/>
      <small style="font-weight:100">von der Maase et al. J Clin Oncol 2000 (v1.0) ; von der Maase et al. J Clin Oncol 2005 (v1.0)</small>
    </h2>
    <img src="../../assets/step5/map4.jpg" v-if="coverData === 1" class="cover" alt="">
    <img src="../../assets/step5/map4-2.jpg" v-if="coverData === 2" class="cover" alt="">
    <img src="../../assets/step5/map4-3.jpg" v-if="coverData === 3" class="cover" alt="">
    <img src="../../assets/step5/map4-4.jpg" v-if="coverData === 4" class="cover" alt="">
    <foot-component :text="footText"></foot-component>
    <template>
      <router-link to="/step5-6" v-if="coverData === 1" class="btn-prev el-icon-arrow-left"></router-link>
      <a href="" v-if="(coverData > 1) || (coverDava < 4)" class="btn-prev el-icon-arrow-left" @click.prevent="coverData = coverData-1"></a>
      <a href="" v-if="coverData !== 4" class="btn-next el-icon-arrow-right" @click.prevent="coverData = coverData+1"></a>
    </template>
  </div>
</template>

<script>
import footText from './footText'
export default {
  name: 'page8',
  data () {
    return {
      coverData: 1,
      footText: '1. von der Maase et al. J Clin Oncol 2000; 2. von der Maase et al. J Clin Oncol 2005;<br/>3. Sternberg et al. Eur J Cancer 2006 4. Bellmunt et al. J Clin Oncol 2012; 5. De Santis et al. J Clin Oncol 2012'
    }
  },
  components: {
    'foot-component': footText
  }
}
</script>

<style scoped>
  .page-title {
    color:#1367a2;letter-spacing:.5pt;
    margin:0;margin-bottom:10px;font-size:18px;
    font-weight:bold;
  }
  .cover {width:100%;margin-bottom:130px;}
  a[class*="btn-"]{
    background:#1367a2;color:white;
  }
  @media(max-width:750px){
    .container,
    .foot-small {width:90%;margin:20px auto;margin-left:5%;}
    a.btn-next {right:10px;}
  }
</style>



// WEBPACK FOOTER //
// src/components/step5/page8.vue